export const PARTNER_API_DOCS_METHODS = {
    CREATE_LEAD: 'create_lead',
    GET_STATISTICS: 'get_statistics',
}
